module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-react-router-scroll/~/babel-runtime/core-js/object/create.js
// module id = ./node_modules/gatsby-react-router-scroll/node_modules/babel-runtime/core-js/object/create.js
// module chunks = 168707334958949